import React from "react";
import { Table } from "antd";
import moment from "moment";
import { render } from "@testing-library/react";

export default function Peers(props) {

    const { data = {} } = props;

    const rawData = [data];

    const monthLabels = Array.from({ length: 13 }, (_, i) =>
        moment().subtract(12 - i, "months").format("MMM")
    );

    // Create columns
    const columns = [
        {
            title: <small>Peers</small>,
            dataIndex: "total_stores",
            key: "total_stores",
            render: (e) => {
                return (<span style={{ "color": "#a52a2a" }}><nobr>{e} Peers</nobr></span>)
            }
        },
        ...monthLabels.map((month, index) => ({
            title: <small>{month}</small>,
            dataIndex: `month_${index}`,
            className: (index < 8) ? "hide-small" : "",
            key: `month_${index}`,
            align: "right", render: (e) => {
                return (<span style={{ "color": "#a52a2a" }}>{e}</span>)
            }
        })),
        {
            title: <small>Wk</small>,
            dataIndex: "week",
            key: "week",
            align: "right",
            render: (e) => {
                return (<span style={{ "color": "#a52a2a" }}>{e}</span>)
            }
        },
        {
            title: <small style={{ "color": "#3c8617" }}>OH</small>,
            key: "oh",
            align: "right",
            render: (_, record) => (
                <span style={{ "color": "#a52a2a" }}>
                    {record.onhand}<sup>{record.onhandlocs}</sup>
                </span>
            )
        },
        {
            title: <small style={{ "color": "#e77e21" }}>OO</small>,
            key: "oo",
            align: "right",
            render: (_, record) => (
                <span style={{ "color": "#a52a2a" }}>
                    {record.onorder}<sup>{record.onorderlocs}</sup>
                </span>
            )
        }
    ];

    // Flatten data for table rows
    const dataSource = rawData.map((item, index) => {
        const monthData = {};
        item.months.forEach((value, idx) => {
            monthData[`month_${idx}`] = value;
        });
        return {
            key: index,
            ...item,
            ...monthData
        };
    });




    return (<div>
        <div style={{ "fontSize": "13px", "fontWeight": "500" }}>Peers</div>
        <Table size="small" className={"mediumTable bc"} style={{ "width": "100%", "border": "1px solid #eee", "borderBottom": "0px" }} columns={columns} dataSource={dataSource} pagination={false} /></div>);
}
